import { useState } from 'react'
import { Button, Spinner } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { ModalSubjects } from 'components/shared/ModalSubjects'
import { APISERVICE } from 'services/api.service'
import { updateTeacherInfo } from 'redux/states/docente'
import SubjectInfo from './SubjectInfo'
import { BsArrowCounterclockwise } from 'react-icons/bs'
import { useSchedule } from 'hooks/useSchedule'
import { useServerDate } from 'hooks/useServerDate'

export default function Control() {
    const dispatch = useDispatch()
    const { classStarted, teacherInfo, infoSchedule } = useSelector((store) => store.teacher)
    const { timeString, localeDateTimeString } = useServerDate()
    const { getDailySchedules, loading } = useSchedule()
    const [showModal, setShowModal] = useState(false)

    const startClass = async () => {
        const schedule = infoSchedule.schedule
        const url = 'verificacion/start-class'
        const data = { horario_id: schedule.id, hora_inicio: schedule.hora_inicio, hora_fin: schedule.hora_fin }
        const response = await APISERVICE.post(url, '', data)
        if (response.success) {
            const infoSchedule = {
                infoSchedule: {
                    schedule: schedule,
                    notificationSchedules: response.data,
                },
                classStarted: {
                    active: !classStarted.active,
                    startClass: timeString,
                },
            }
            dispatch(updateTeacherInfo(infoSchedule))
        }
    }
    const handleReload = () => {
        getDailySchedules()
    }

    return (
        <div className='home-teacher py-3'>
            <div>Fecha: {localeDateTimeString}</div>
            <div>Docente: {teacherInfo?.nombre}</div>
            <div className='mb-3'>
                <span className='me-2'>Materias:</span>
                <Button variant='blue' size='sm' onClick={() => setShowModal(true)}>
                    Ver detalle
                </Button>
            </div>
            <div className='d-flex mb-5'>
                <div className='mx-auto fs-2 text-center' style={{ borderBottom: '2px solid #000' }}>
                    CONTROL DE CLASES VIRTUALES
                </div>
            </div>

            <SubjectInfo startClass={startClass} />
            {classStarted.endClass?.length > 0 ? (
                <p className='text-center fs-5'>
                    <span className='fw-bold'>Clase terminada:</span> {classStarted.endClass}
                </p>
            ) : (
                Object.keys(infoSchedule).length === 0 && (
                    <div>
                        <div className='text-center'>
                            <p className='fs-5'>No hay clases pendientes!</p>
                            <button className='btn btn-blue' onClick={handleReload} disabled={loading}>
                                <span className='me-2'>
                                    {loading ? <Spinner size='sm' /> : <BsArrowCounterclockwise />}
                                </span>
                                Actualizar clases pendientes
                            </button>
                        </div>
                    </div>
                )
            )}
            <ModalSubjects
                show={showModal}
                onHide={() => setShowModal(false)}
                teacherId={teacherInfo?.teacherId}
                header={teacherInfo?.nombre}
            />
        </div>
    )
}
